import moment from 'moment'

const titleize = (title: string) => {
  const titleToLowerCase = title.toLowerCase().split(' ')
  const titlizedArray = titleToLowerCase.map(
    (word, idx) => word.charAt(0).toUpperCase() + word.slice(1)
  )
  return titlizedArray.join(' ')
}

const formatDate = (value: string) => moment.utc(value).format('M/D/YYYY')

const formatDateForm = (value: string | undefined) => {
  if (!value) return null
  return moment.utc(value).format('YYYY-MM-DD')
}

const DATE_PREFIX = 'dddd, MMM D'
const TIME_SUFFIX = 'hh:mm A'
const LOCAL_TIMEZONE =
  new Intl.DateTimeFormat(navigator.language, {
    timeZoneName: 'short',
  })
    .formatToParts(new Date())
    .find((p) => p.type === 'timeZoneName')?.value || ''
export const formatDateTimeRange = (valueA: string, valueB: string) => {
  const dateA = moment(valueA)
  const dateB = moment(valueB)

  if (
    dateA.isValid() &&
    dateB.isValid() &&
    dateA.format(DATE_PREFIX) === dateB.format(DATE_PREFIX)
  ) {
    return `${dateA.format(DATE_PREFIX)}, ${dateA.format(
      TIME_SUFFIX
    )} - ${dateB.format(TIME_SUFFIX)} ${LOCAL_TIMEZONE}`
  }

  if (dateA.isValid() && dateB.isValid()) {
    return `${dateA.format(DATE_PREFIX)}, ${dateA.format(
      TIME_SUFFIX
    )} - ${dateB.format(DATE_PREFIX)}, ${dateB.format(
      TIME_SUFFIX
    )} ${LOCAL_TIMEZONE}`
  }

  if (dateA.isValid()) {
    return `${dateA.format(DATE_PREFIX)}, ${dateA.format(
      TIME_SUFFIX
    )} ${LOCAL_TIMEZONE}`
  }

  if (dateB.isValid()) {
    return `${dateB.format(DATE_PREFIX)}, ${dateB.format(
      TIME_SUFFIX
    )} ${LOCAL_TIMEZONE}`
  }

  return ''
}

export default { titleize, formatDate, formatDateForm }
